<template>
  <a
    v-if="hasBannerImage"
    :href="interstitial.ctaLink || null"
    :target="interstitial.ctaLink ? '_blank' : null"
    class="interstitial-banner-link"
    :style="{ '--interstitial-banner-entrance-delay': `${entranceDelay}s` }"
  >
    <v-card elevation="2" class="interstitial-banner-card card-corner-radius mt-4">
      <div class="interstitial-banner-image-wrap">
        <v-img :src="interstitial.bannerImage.src" :aspect-ratio="200/40" contain/>
        <span class="interstitial-banner-shine"/>
      </div>
      <v-footer v-if="interstitial.ctaText" color="white" class="interstitial-banner-caption">
        <v-spacer/>
        <small>{{ interstitial.ctaText }}</small>
        <v-spacer/>
      </v-footer>
    </v-card>
  </a>
</template>

<script>
export default {
  name: 'InterstitialBannerPreview',
  props: {
    interstitial: {
      type: Object,
      default: () => ({})
    },
    entranceDelay: {
      type: Number,
      default: 0
    }
  },
  computed: {
    hasBannerImage: function() {
      return !!(this.interstitial
        && this.interstitial.bannerImage
        && !this.interstitial.bannerImage.deleted
        && this.interstitial.bannerImage.src)
    }
  }
}
</script>

<style scoped>
.interstitial-banner-link {
  display: block;
  text-decoration: none;
}

.interstitial-banner-card {
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.interstitial-banner-link:hover .interstitial-banner-card,
.interstitial-banner-link:active .interstitial-banner-card {
  transform: translateY(-2px) scale(1.015);
  box-shadow: 0 12px 28px rgba(2, 119, 189, 0.2);
}

.interstitial-banner-image-wrap {
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #eef2f7, #ffffff);
}

.interstitial-banner-shine {
  position: absolute;
  top: 0;
  left: -60%;
  width: 35%;
  height: 100%;
  background: linear-gradient(115deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.55) 50%, rgba(255, 255, 255, 0) 100%);
  transform: skewX(-20deg);
  pointer-events: none;
}

.interstitial-banner-caption {
  font-weight: 600;
  font-size: 0.8rem;
  letter-spacing: 0.01em;
}

@media (prefers-reduced-motion: no-preference) {
  .interstitial-banner-card {
    animation: interstitial-banner-fade-up 0.5s ease both;
    animation-delay: var(--interstitial-banner-entrance-delay, 0s);
  }

  .interstitial-banner-shine {
    animation: interstitial-banner-shine-sweep 3.2s ease-in-out infinite;
    animation-delay: 1.2s;
  }
}

@keyframes interstitial-banner-fade-up {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes interstitial-banner-shine-sweep {
  0% {
    left: -60%;
  }
  35% {
    left: 130%;
  }
  100% {
    left: 130%;
  }
}
</style>
